import serviceClient from '../../service-client/service-client';

export default function fetchSiteBackups(params) {
  return async () => {
    const apiClient = serviceClient.get();
    const response = await apiClient.getSiteBackups(params);
    return response.data.results;
  };
}
